import { useCurrentUser } from '@/hooks/data/user';
import Link from 'next/link';
import ProTag from './ProTag';
import styles from './UpgradeWidget.module.css';

export default function UpgradeWidget() {
   const { user, error, isLoading } = useCurrentUser();

   if (isLoading || error) return null;

   if (user?.isPremium) return null;

   return (
      <>
         <Link href="/upgrade">
            <div className={styles.upgradeWidgetContainer}>
               <div className={styles.upgradeWidget}>
                  <ProTag />
                  <h4>Upgrade to Pro</h4>
               </div>
               <p>Elevate Your Presentations with Exclusive Features</p>
            </div>
         </Link>
      </>
   );
}
